module.exports = __webpack_public_path__ + "img/function03.07f9fe4f.png";